export const researchPrivateRoutesConstants = {
  root: {
    path: "/r/app/research",
    href: (projectId: string) => `/r/app/research?project=${projectId}`
  },
  single_research: {
    path: "/r/app/research/:researchId",
    href: (researchId: number, projectId: string, observationId = "") =>
      `/r/app/research/${researchId}?project=${projectId}${
        observationId ? `&observation=${observationId}` : ""
      }`
  },
  observations: {
    path: "/r/app/research/observations",
    href: (projectId?: string) =>
      `/r/app/research/observations?project=${projectId || "all"}`
  }
} as const;
